import { Component } from '@angular/core';
import { Router} from '@angular/router';
import {GridBaseCase} from '../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent extends GridBaseCase {
//判断当前template.content.configName是否存在
isgridViewConfigName:boolean = false;
constructor(private router:Router,
  private com: CommonService,
  )
 {
   super();
 }
 ngOnInit(){

 }
getAction(){
  const date=new Date();
  // this.router.navigateByUrl("/tabs/list/"+date.getSeconds());
  this.com.Go("/tabs/list/"+date.getSeconds());
 }
}
